import { IntlProvider } from 'app/shared/providers/intl-provider';
import { AppRouter } from 'app/components/router';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider } from 'app/shared/contexts/api';
import { BuildingProvider } from 'app/shared/contexts/building';
import { UserProvider } from 'app/shared/contexts/user';
import { FeatureFlagsProvider } from 'app/shared/contexts/feature-flags';
import { ThemeProvider } from 'app/shared/contexts/theme';
import { MiniappSdkProvider } from 'app/shared/contexts/miniapp-sdk';
import { QueryClientProvider } from 'app/shared/providers/query-client-provider';
import { ErrorsProvider } from 'app/shared/contexts/errors';
import { TokenRefreshManager } from 'app/components/token-refresh-manager';
import { HeaderNavManager } from 'app/components/header-nav-manager';
import '../index.css';

export const App = (): JSX.Element => (
  <ErrorsProvider>
    <QueryClientProvider>
      <BrowserRouter>
        <ApiProvider>
          <MiniappSdkProvider>
            <TokenRefreshManager />
            <UserProvider>
              <IntlProvider>
                <BuildingProvider>
                  <ThemeProvider>
                    <FeatureFlagsProvider>
                      <HeaderNavManager />
                      <AppRouter />
                    </FeatureFlagsProvider>
                  </ThemeProvider>
                </BuildingProvider>
              </IntlProvider>
            </UserProvider>
          </MiniappSdkProvider>
        </ApiProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ErrorsProvider>
);
